// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"228":"abad2167","253":"12e06688","380":"c2aa7ae4","394":"2b76fa6e","420":"4eb1f4c9","450":"230fe6fd","657":"bff26389","865":"e2de345e","890":"306daba5","892":"f31d17fb","927":"dd92d8a9"}[chunkId] + ".chunk.css";
};